// DataService
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private ladataSource = new BehaviorSubject<any>(null);
  ladata$ = this.ladataSource.asObservable();

  constructor() {
    const storedData = localStorage.getItem('ladata');
    if (storedData) {
      this.ladataSource.next(JSON.parse(storedData));
    }
  }

  setLadata(ladata: any) {
    this.ladataSource.next(ladata);
    localStorage.setItem('ladata', JSON.stringify(ladata));
  }

  getLadata() {
    return this.ladataSource.getValue();
  }

  clear(): void {
    this.ladataSource.next(null);
  }
}
